import z from 'zod'

export enum QuickAccess {
  SIDEBAR = 'sidebar',
  TOOLS = 'tools',
}

export const generalSettingsModel = z.object({
  id: z.string(),
  friendlyUrlOrigin: z.string().url().array(),
  toolsMenu: z.boolean(),
  quickAccess: z.boolean(),
  singleSignOn: z.boolean(),
  enableAccountEntity: z.boolean(),
  features: z.object({
    application_url: z.string().url(),
    show_quick_access: z.nativeEnum(QuickAccess).nullable(),
  }),
  startDate: z.date(),
  endDate: z.date().nullable(),
  isActive: z.boolean(),
  createdAt: z.date().nullable(),
  updatedAt: z.date().nullable(),
})

export type GeneralSettingsModel = z.infer<typeof generalSettingsModel>
